import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import "./global.css";
import App from "./App";
// Register shortcut handlers at the TOP LEVEL — Excel's shortcut system
// looks for these immediately on script load, before Office.onReady resolves.
async function ensureVisible() {
    try {
        await Office.addin.showAsTaskpane();
    }
    catch {
        /* already visible */
    }
}
Office.actions.associate("TracePrecedents", async (event) => {
    try {
        await ensureVisible();
        if (window.__gridrive?.handleTrace) {
            await window.__gridrive.handleTrace();
        }
    }
    finally {
        event?.completed();
    }
});
Office.actions.associate("TraceDependents", async (event) => {
    try {
        await ensureVisible();
        if (window.__gridrive?.handleDependents) {
            await window.__gridrive.handleDependents();
        }
    }
    finally {
        event?.completed();
    }
});
Office.actions.associate("OpenGridrive", async (event) => {
    try {
        await ensureVisible();
        if (window.__gridrive?.handleOpenGridrive) {
            await window.__gridrive.handleOpenGridrive();
        }
    }
    finally {
        event?.completed();
    }
});
Office.onReady((info) => {
    if (info.host !== Office.HostType.Excel) {
        return;
    }
    const root = createRoot(document.getElementById("root"));
    root.render(_jsx(App, {}));
});
